import React from 'react';

import CharacterClass from './CharacterClass';
const Power = React.lazy(() => import('./Power'));
const Upgrade = React.lazy(() => import('./Upgrade'));
const Performance = React.lazy(() => import('./Performance'));
const WinRate = React.lazy(() => import('./WinRate'));

export { CharacterClass, Power, Upgrade, Performance, WinRate };
